import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "c-rich-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SanityBlocks = _resolveComponent("SanityBlocks")!
  const _component_Grid = _resolveComponent("Grid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blocksAndImages, (blocksOrImage, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (blocksOrImage._type !== 'image')
          ? (_openBlock(), _createBlock(_component_Grid, {
              size: _ctx.gridSize,
              key: i,
              class: _normalizeClass({ 'p-none': _ctx.gridSize === 'none' })
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SanityBlocks, {
                  blocks: blocksOrImage,
                  serializers: _ctx.serializers
                }, null, 8, ["blocks", "serializers"])
              ]),
              _: 2
            }, 1032, ["size", "class"]))
          : (_openBlock(), _createBlock(_component_Grid, {
              size: _ctx.gridSize,
              key: `else-${i}`,
              class: "c-rich-text__image-wrapper"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SanityBlocks, {
                  blocks: [blocksOrImage],
                  serializers: _ctx.serializers
                }, null, 8, ["blocks", "serializers"])
              ]),
              _: 2
            }, 1032, ["size"]))
      ], 64))
    }), 256))
  ]))
}